module.exports = __webpack_public_path__ + "static/demolition-tank_removal-068d8ad1d6cfef91478355a28606b404.png";